import { useContext, useMemo } from 'react';

import { BreakpointContext, Breakpoint } from '@hh.ru/magritte-ui-breakpoint/BreakpointProvider';

export interface UseBreakpoint {
    breakpoint: Breakpoint;
    isXS: boolean;
    isS: boolean;
    isM: boolean;
    isL: boolean;
    isXL: boolean;
    isXXL: boolean;
    isMobile: boolean;
    isGtXS: boolean;
    isGtS: boolean;
    isGtM: boolean;
    isGtL: boolean;
}

const useBreakpoint: () => UseBreakpoint = () => {
    const { breakpoint } = useContext(BreakpointContext);

    const breakpointMap = useMemo(
        () => ({
            isXS: breakpoint === Breakpoint.XS,
            isS: breakpoint === Breakpoint.S,
            isM: breakpoint === Breakpoint.M,
            isL: breakpoint === Breakpoint.L,
            isXL: breakpoint === Breakpoint.XL,
            isXXL: breakpoint === Breakpoint.XXL,
            isMobile: [Breakpoint.XS, Breakpoint.S].includes(breakpoint),
            isGtXS: [Breakpoint.S, Breakpoint.M, Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
            isGtS: [Breakpoint.M, Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
            isGtM: [Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
            isGtL: [Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
            breakpoint,
        }),
        [breakpoint]
    );

    return breakpointMap;
};

export default useBreakpoint;
